module.exports = __webpack_public_path__ + "media/images/site/tack-a08e13b740249bcfb711b327b3308095.svg";